<template>
    <a-icon
        v-if="playerIsPlaying"
        v-on:click="pause"
        class="play-button"
        type="pause-circle" />
    <a-icon
        v-else
        v-on:click="play"
        class="play-button"
        type="play-circle" />
</template>

<script>
 import EventBus from '../event/event-bus.js'
 import Vue from 'vue';
 import Icon from "ant-design-vue/lib/icon";

 import { mapGetters } from 'vuex'

 Vue.component(Icon.name, Icon);

 export default {
     name: 'MediaButton',
     props: {
     },
     components: {
     },
     computed: {
         ...mapGetters([
             "playerIsPlaying"
         ])
     },
     methods: {
         play: function() {
             EventBus.$emit("playerPlay")
         },

         pause: function() {
             EventBus.$emit("playerPause")
         }
     }
 }
</script>

<style scoped>
 .play-button {
     font-size: 24px;
     color: #EEE;

     margin-right: 10px;
 }
</style>
